export enum AudioPriorityGroup {
  UNMASKABLE_SOUND = 0,
  MUSIC_STINGERS = 1,
  MUSIC_STREAMS = 2,
  ONE_SHOT_STREAMS = 3,
  LOOPING_AREAWIDE_AMBIENTS = 4,
  LOOPING_POSITIONAL_AMBIENTS = 5,
  LOOPING_PLAYER = 6,
  LOOPING_NONPLAYER = 7,
  PLAYER_CHAT = 8,
  NON_PLAYER_CHAT = 9,
  SCRIPTED_PLAYSOUND = 10,
  GUI = 11,
  AREA_SPELL_EFFECTS = 12,
  NORMAL_SPELL_EFFECTS = 13,
  PROJECTILE = 14,
  COMBAT = 15,
  LARGE_CREATURE_VOCALIZATIONS = 16,
  MEDIUM_AND_SMALL_CREATURE_VOCALIZATIONS = 17,
  LARGE_CREATURE_FOOTSTEPS = 18,
  PLAYER_FOOTSTEPS = 19,
  MEDIUM_AND_SMALL_CREATURE_FOOTSTEPS = 20,
  SINGLE_SHOT_GLOBAL = 21,
  SINGLE_SHOT_POSITIONAL = 22,
  DEFAULT = 23,
  MINIGAME_ENEMY = 24,
  ROOM_SOUNDS = 25,
  BARK_BUBBLES = 26
}